// useHealth — lightweight health-only poll for the app shell. The full
// market data is loaded by MarketView; this hook just keeps the header
// counts and freshness pill warm regardless of the current route.

import { useEffect, useState } from "react";
import axios from "axios";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

const useHealth = () => {
    const [health, setHealth] = useState(null);
    useEffect(() => {
        let cancelled = false;
        const fetchHealth = async () => {
            try {
                const r = await axios.get(`${API}/health`);
                if (!cancelled) setHealth(r.data);
            } catch {
                /* silent — header just hides counts until the next try */
            }
        };
        fetchHealth();
        const id = setInterval(fetchHealth, 60_000);
        return () => { cancelled = true; clearInterval(id); };
    }, []);
    return health;
};

export default useHealth;
